export default __webpack_public_path__ + "static/media/Glodani 2.62a84577.jpg";